var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideOutArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "63px",
    viewBox: "0 0 12 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "94B0F04A-4199-43B7-AAAB-9728A9485733") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Documents",
    transform: "translate(-367.000000, -179.000000)",
    fill: "#006C80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(372.460460, 210.694161) scale(-1, 1) translate(-372.460460, -210.694161) translate(361.210460, 168.694161)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Side-Out-Arrow",
    transform: "translate(10.979357, 42.000000) scale(-1, 1) rotate(90.000000) translate(-10.979357, -42.000000) ",
    points: "10.9793566 36.3610684 42.4206723 47.6389316 -20.4619591 47.6389316"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideOutArrow);
export default __webpack_public_path__ + "static/media/side-out-arrow.eb4901c5170d7f1811b9fb739ca2d03e.svg";
export { ForwardRef as ReactComponent };